import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "settings" }
const _hoisted_2 = { class: "settings__main" }
const _hoisted_3 = { class: "settings__title h1 color-text-primary" }
const _hoisted_4 = { class: "settings__sections" }
const _hoisted_5 = ["onClick"]

import { onMounted, ref } from "vue";
import BaseButton from "@/components/base/BaseButton.vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportView',
  setup(__props) {

const router = useRouter();

const store = useStore();
const { t } = useI18n();

const sections = ref([
  {
    title: t("support.sections.faq"),
    step: "faq",
  },
  {
    title: t("support.sections.feedback"),
    step: "feedback",
  },
]);

const setSettingsStep = (sectionsStep: string) => {
  if (sectionsStep === "faq") {
    router.push("/faq");
  } else if (sectionsStep === "feedback") {
    router.push("/feedback");
  }
};

const clearData = async () => {
  store.dispatch("auth/logout");
};

onMounted(() => {
  store.dispatch("updateAsideVisibility", false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("support.title")), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "settings__section h4 color-text-primary",
            onClick: ($event: any) => (setSettingsStep(item.step))
          }, [
            _createTextVNode(_toDisplayString(item.title) + " ", 1),
            _createVNode(BaseFigureForIcon, {
              icon: "more",
              color: "secondary",
              size: "small",
              "is-button": ""
            })
          ], 8, _hoisted_5))
        }), 128))
      ]),
      _createVNode(BaseButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (clearData())),
        title: _unref(t)('support.logout'),
        size: "large",
        color: "transparent-primary",
        class: "logout-btn"
      }, null, 8, ["title"])
    ])
  ]))
}
}

})